var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 37,
    viewBox: "0 0 120 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2416 4.71215L30.1202 8.32484H24.5127L25.6342 4.71215H31.2416ZM22.1095 16.9638L23.3912 12.4087H29.4793C32.6835 12.4087 34.6061 10.995 35.5674 8.01066L36.048 6.28289C37.1695 2.51316 35.4072 0 31.2416 0H4.96663L0 16.8067H22.1095V16.9638Z",
    fill: "#F2F740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3402 4.7121H47.423V10.0525H42.2959L45.3402 4.7121ZM38.2906 16.9637L39.8927 14.1364H47.423V16.9637H52.3892V0.156982H42.7764L32.6831 16.9637H38.2906Z",
    fill: "#F2F740"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4824 4.7121H67.9301L66.9686 8.32473H61.3611L62.4824 4.7121ZM72.4158 8.0106L72.8963 6.43987C74.0181 2.51306 72.2555 0.156982 68.0899 0.156982H58.7978L53.8311 16.9637H58.9581L60.2397 12.4086H63.4438L64.8858 16.9637H70.1727L68.5709 12.0945C70.4934 11.4662 71.775 10.2096 72.4158 8.0106Z",
    fill: "#F2F740"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2232 16.9637L82.1895 0.156982H77.0629L72.0962 16.9637H77.2232Z",
    fill: "#F2F740"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1805 19.3198L39.2524 26.0739L37.0094 19.3198H14.7397L9.93335 36.1266H32.0428L34.7664 26.8593L36.5288 32.0427H39.7331L44.5397 26.5451L41.8156 36.1266H46.9426L51.749 19.3198H45.1805Z",
    fill: "#F2F740"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1572 29.2154L61.2015 23.8749H63.2843V29.2154H58.1572ZM58.6382 19.3198L48.5444 36.1266H54.3123L55.9146 33.2992H63.4446V36.1266H68.4108V19.3198H58.6382Z",
    fill: "#F2F740"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7138 24.1891L86.9954 19.3198H71.4549L70.0129 24.1891H75.6205L72.2561 36.1266H77.3826L80.747 24.1891H85.7138Z",
    fill: "#F2F740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4435 24.1891H100.294L101.736 19.3198H93.405C90.2009 19.3198 88.2779 20.7335 87.3169 23.7178L85.5543 29.8437C84.433 33.7705 86.1951 36.1266 90.3607 36.1266H96.7694L98.2114 31.2573H90.3607L92.4435 24.1891Z",
    fill: "#F2F740"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.873 19.3198L113.111 25.4457H107.343L109.105 19.3198H103.979L99.0122 36.1266H104.139L105.901 30.1578H111.829L110.067 36.1266H115.194L120 19.3198H114.873Z",
    fill: "#F2F740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMob);
export default __webpack_public_path__ + "static/media/logo-mob.0c81c1b57615df543b44c8e243552182.svg";
export { ForwardRef as ReactComponent };